import { FC } from 'react'
import { ErrorResponse, SuccessResponse } from 'ts/types/ApiResponse'
import { Card, Error, Success } from './ui'

type Props = {
  success?: SuccessResponse | null
  error?: ErrorResponse | null
  title?: string | null
  description?: string | null
}

const ModalCard: FC<Props> = ({ 
  success, error, title, description, children
  }) => (
  <>

    <div className="flex">
      {error ? <Error data={error} /> : null}
      {success ? <Success success={success} /> : null}
    </div>

    <Card className="px-8 py-6">
      {title ? (
        <h1 className="text-lg font-bold">{title}</h1>
      ) : null}
      {description ? (
        <h1 className="text-sm text-gray-400">{description}</h1>
      ) : null}
      <div className='shrink-0 bg-border h-025 w-full my-5'></div>
      <div className="flex">{children}</div>
    </Card>
  </>
)

export default ModalCard
